import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import { useAccessToken } from '../../../components/common/hooks/useAccessToken';
import {isAdminSelector, isDevSelector} from '../../../components/store/auth/selectors';
import { showLoader, hideLoader } from '../../../components/store/common/slice';
import PartnersAndBuildingsDropdown from '../../components/PartnersAndBuildingsDropdowns/PartnersAndBuildingsDropdowns';
import { StyledButtonWrapper } from '../RenewReports/RenewReports.styled';
import { StyledWrapper } from './SmsReports.styled';
import Checkbox from "../../../components/common/simple/Checkbox";

const SmsReports = () => {
    const isAdmin = useSelector(isAdminSelector);
    const { t } = useTranslation();
    const client = useAccessToken();
    const dispatch = useDispatch();
    const isDeveloper = useSelector(isDevSelector);

    const [currentPartner, setCurrentPartner] = useState([]);
    const [currentBuildings, setCurrentBuildings] = useState([]);
    const [generateBtnDisabled, setGenerateBtnDisabled] = useState(true);
    const [isRawReport, setIsRawReport] = useState(false);

    const onPartnerChange = e => setCurrentPartner(e);

    useEffect(() => {
        if (currentPartner.length > 0) setGenerateBtnDisabled(false);
        else setGenerateBtnDisabled(true);
    }, [currentPartner]);

    const onBuildingsChange = e => setCurrentBuildings(e);

    const createPayloadArr = arr => {
        let options = [];
        arr.map(item => options.push(item.value));
        return options
    };

    const onGenerateClick = async () => {
        dispatch(showLoader());
        let filter;
        if (currentPartner.length === 1 && currentBuildings.length > 0) {
            filter = {
                building_ids: createPayloadArr(currentBuildings)
            };
        } else {
            filter = {
                partner_ids: createPayloadArr(currentPartner)
            };
        }
        let result;
        if (isRawReport) {
            NotificationManager.error('Raw report is unavailable now')
            // result = await client.post('/operations/sms-report-all-bllink/?rawReport=true');
        } else {
            result = await client.post('/operations/sms-report-all-bllink/', {filter: filter});
        }
        dispatch(hideLoader());
        if (result.sent) NotificationManager.success(t('adminReports.success'))
        else NotificationManager.error(t('buildings.something_wrong'))
    };

    if (!isAdmin) return <div>{t('searchPayments.noAdminRights')}</div>;

    return (
        <>
            <StyledWrapper>
                <PartnersAndBuildingsDropdown
                    disabled={isRawReport}
                    onPartnerChange={onPartnerChange}
                    onBuildingsChange={onBuildingsChange}
                />
            </StyledWrapper>
            {isDeveloper && <Checkbox
                label={t('adminReports.rawReport')}
                checked={isRawReport}
                onChange={bool => setIsRawReport(bool)}
            />}
            <StyledButtonWrapper>
                <button
                    className='bllink-button'
                    onClick={onGenerateClick}
                    disabled={generateBtnDisabled && !isRawReport}
                >
                    {t('adminReports.generateBtn')}
                </button>
            </StyledButtonWrapper>
        </>
    );
};

export default SmsReports;
